import React, { useEffect, useState } from "react";
import { Radio, Select } from "antd";
import MonthFrequencyControl from "./MonthFrequencyControl";
import WeeklyFrequencyControl from "./WeeklyFrequencyControl";
import SlotBasedFrequencyControl from "./SlotBasedFrequencyControl";
import { mapIntentToRequest } from "../../../../service/network/RequestMapper";
import IntentType from "../../../../intentexecutor/utils/IntentType";
import { performPostRequest } from "../../../../service/network/NetworkService";
import { getApiUrl } from "../../../../service/network/UrlMapper";
import { useGetOrgIdentifier } from "../../../generic/hooks/useGetOrgIdentifier";

const VolunteerFrequency = ({
  setCarePlan,
  visitStartDate,
  carePlan,
  readOnly,
  patientName,
  typesOfServicesSelected,
  defaultMonths,
  onConfirmShifts,
  confirmShiftsLoading
}) => {
  const organizationIdentifier = useGetOrgIdentifier();
  const [optionsList, setOptionsList] = useState([]);
  const [frequencyPeriodOptions, setFrequencyPeriodOptions] = useState([]);
  const [frequencyPeriod, setFrequencyPeriod] = useState(
    carePlan?.frequencyPeriod,
  );
  const [onGoingFrequency, setOnGoingFrequency] = useState(["1-2x"]);

  const handleFrequencyPeriodChange = (e) => {
    setFrequencyPeriod(e.target.value);
    if (e.target.value === "no repeat" || e.target.value === "on going") {
      setCarePlan((prev) => ({
        ...prev,
        frequencyPeriod: e.target.value,
        frequency: e.target.value === "on going" ? onGoingFrequency : [],
      }));
    } else if (e.target.value === "slot based") {
      setCarePlan((prev) => ({
        ...prev,
        frequencyPeriod: e.target.value,
        frequency: [],
      }));
    } else {
      setCarePlan((prev) => ({ ...prev, frequencyPeriod: e.target.value }));
    }
  };

  const handleOnGoingFrequencyChange = (value) => {
    setOnGoingFrequency([value]);
    setCarePlan((prev) => ({
      ...prev,
      frequency: [value],
    }));
  };

  useEffect(() => {
    setCarePlan((prev) => ({
      ...prev,
      frequencyPeriod: frequencyPeriod,
    }));
  }, [frequencyPeriod, setCarePlan]);

  useEffect(() => {
    if (carePlan?.frequencyPeriod) {
      setFrequencyPeriod(carePlan.frequencyPeriod);
    }
    if (carePlan?.frequency && carePlan?.frequencyPeriod === "on going") {
      setOnGoingFrequency(carePlan.frequency);
    }
  }, [carePlan.frequency, carePlan.frequencyPeriod]);

  useEffect(() => {
    const fetchSourceList = async () => {
      const payload = {
        configurationKey: [
          "niramaya.request.form.frequencies",
          "niramaya.careplan.frequency.period.options",
        ],
      };
      const request = mapIntentToRequest(
        IntentType.GET_CONFIGURATION,
        payload,
        { organizationIdentifier },
      );
      const result = await performPostRequest(
        getApiUrl()[IntentType.GET_CONFIGURATION],
        JSON.stringify(request),
      );
      const response = await result.json();
      const parsedResult =
        response[0].configurationValue &&
        JSON.parse(response[0].configurationValue);
      const parsedFrequencyPeriods = JSON.parse(
        response[1].configurationValue || "[]",
      );

      setOptionsList(parsedResult);
      setFrequencyPeriodOptions(parsedFrequencyPeriods);
    };

    fetchSourceList();
  }, [organizationIdentifier]);

  return (
    <div className="mt-2">
      <Radio.Group
        onChange={handleFrequencyPeriodChange}
        value={frequencyPeriod}
        className="frequency-radio-button"
        disabled={readOnly}
      >
        {frequencyPeriodOptions?.map(({ value, label }) => (
          <Radio value={value}>{label}</Radio>
        ))}
      </Radio.Group>

      <div className="mt-2">
        {frequencyPeriod === "monthly" && (
          <MonthFrequencyControl
            key={defaultMonths}
            setCarePlan={setCarePlan}
            options={optionsList}
            carePlan={carePlan}
            readOnly={readOnly}
            defaultMonths={defaultMonths}
          />
        )}
        {frequencyPeriod === "weekly" && (
          <WeeklyFrequencyControl
            setCarePlan={setCarePlan}
            options={optionsList}
            visitStartDate={visitStartDate}
            carePlan={carePlan}
            readOnly={readOnly}
          />
        )}
        {frequencyPeriod === "on going" && (
          <Select
            onChange={handleOnGoingFrequencyChange}
            options={optionsList}
            value={onGoingFrequency}
            placeholder="Frequency"
            style={{
              width: 120,
            }}
            className="me-3"
            disabled={readOnly}
          />
        )}
        {frequencyPeriod === "slot based" && (
          <SlotBasedFrequencyControl
            setCarePlan={setCarePlan}
            carePlan={carePlan}
            readOnly={readOnly}
            visitStartDate={visitStartDate}
            patientName={patientName}
            typesOfServicesSelected={typesOfServicesSelected}
            onConfirmShifts={onConfirmShifts}
            confirmShiftsLoading={confirmShiftsLoading}
          />
        )}
      </div>
    </div>
  );
};

export default VolunteerFrequency;
